module.exports = __webpack_public_path__ + "static/lunchtype22-light-webfont-2aaf7c0828acdcd4f3791b44d6d9d644.woff2";